// @flow
import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import Input from '../../components/Input';
import { noValidate, convertValueToBoolean, FirstChild } from '../../helpers';

type Props = {
  isSaving: boolean,
  settings: Object,
  successMsg: string,
  errorMsg: string,
  handleSubmit: (v: Object) => void
};

const SettingsTermsAndConditionsForm = (props: Props) => (
  <Form onSubmit={props.handleSubmit}>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Terms and Conditions Last Updated Date"
          placeholder={
            props.settings && props.settings.tcReleaseDate
              ? props.settings.tcReleaseDate.description
              : ''
          }
          name="tcReleaseDate.value"
          validate={[noValidate]}
          disabled={true}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Terms and Conditions PDF (URL)"
          placeholder={
            props.settings && props.settings.tcPdf
              ? props.settings.tcPdf.description
              : ''
          }
          name="tcPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="toggle"
          label="Terms and Conditions Invalidation Flag"
          name="tcInvalidationFlag.value"
          format={convertValueToBoolean}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12}>
        <Button
          bsStyle="primary"
          type="submit"
          className="relative-padding"
          disabled={props.isSaving}
        >
          {props.isSaving ? 'Saving...' : 'Save'}
        </Button>
      </Col>
    </Row>
    <br />
    <Row>
      <Col sm={12}>
        <CSSTransitionGroup
          component={FirstChild}
          transitionName="fade"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {props.successMsg ? (
            <p key="success" className="text-success">
              {props.successMsg}
            </p>
          ) : null}
        </CSSTransitionGroup>
      </Col>
    </Row>
    {props.errorMsg && (
      <div className="alert alert-danger">{props.errorMsg}</div>
    )}
  </Form>
);

export default reduxForm({
  form: 'settingsTermsAndConditionsForm'
})(SettingsTermsAndConditionsForm);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsTermsAndConditionsForm.js